export const PHONE_LOGIN_ENDPOINTS = {
  "stc.gamezroid.com": "https://vas2.grand-hub.com/api/playIt/stc-d/signIn",
  "lebara.gamezroid.com": "https://vas2.grand-hub.com/api/playIt/lebara-d/signIn",
  "www.lebara.gamezroid.com": "https://vas2.grand-hub.com/api/playIt/lebara-d/signIn",
  "redbull.gamezroid.com": "https://vas2.grand-hub.com/api/playIt/redbull-d/signIn",
  "www.redbull.gamezroid.com": "https://vas2.grand-hub.com/api/playIt/redbull-d/signIn",
  "ksa.gamezroid.com": "https://apissl.playit.mobi/api/v2/loginByPhone",
  "www.ksa.gamezroid.com": "https://apissl.playit.mobi/api/v2/loginByPhone",
  "pro.gamezroid.com": "https://apissl.playit.mobi/api/v2/loginByPhone",
};

export function getPhoneLoginEndpoint(hostname) {
  return PHONE_LOGIN_ENDPOINTS[hostname] || null;
}
